export function Portal8Icon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.66634 9.33329C6.66634 8.9651 6.96482 8.66663 7.33301 8.66663H9.99967C10.3679 8.66663 10.6663 8.9651 10.6663 9.33329C10.6663 9.70148 10.3679 9.99996 9.99967 9.99996H7.33301C6.96482 9.99996 6.66634 9.70148 6.66634 9.33329Z"
        fill="currentColor"
      />
      <path
        d="M7.33301 5.99996C6.96482 5.99996 6.66634 6.29844 6.66634 6.66663C6.66634 7.03482 6.96482 7.33329 7.33301 7.33329H11.333C11.7012 7.33329 11.9997 7.03482 11.9997 6.66663C11.9997 6.29844 11.7012 5.99996 11.333 5.99996H7.33301Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.33301 2.66663C2.22844 2.66663 1.33301 3.56206 1.33301 4.66663V11.3333C1.33301 12.4379 2.22844 13.3333 3.33301 13.3333H12.6663C13.7709 13.3333 14.6663 12.4379 14.6663 11.3333V4.66663C14.6663 3.56206 13.7709 2.66663 12.6663 2.66663H3.33301ZM2.66634 4.66663C2.66634 4.29844 2.96482 3.99996 3.33301 3.99996H3.99967V12H3.33301C2.96482 12 2.66634 11.7015 2.66634 11.3333V4.66663ZM5.33301 12H12.6663C13.0345 12 13.333 11.7015 13.333 11.3333V4.66663C13.333 4.29844 13.0345 3.99996 12.6663 3.99996H5.33301V12Z"
        fill="currentColor"
      />
    </svg>
  );
}
